import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useCallback, useState } from 'react';
import { ComboBox } from '@skbkontur/react-ui';
import { DirectoryBoxRow } from './components/DirectoryBoxRow';
import { TotalCountRow } from './components/TotalCountRow';
import { totalCountRows } from './DirectoryBox.constants';
import { getComboBoxValue, searchItem } from './DirectoryBox.helpers';
export const DirectoryBox = forwardRef(({ error, value, items, onBlur, width = 400, maxMenuHeight, onValueChange, onFocus, placeholder, 'data-tid': dataTid, }, ref) => {
    const [totalCount, setTotalCount] = useState(0);
    const getItems = useCallback(
    // eslint-disable-next-line @typescript-eslint/require-await
    async (query) => {
        const results = searchItem(items, query);
        setTotalCount(results.length);
        return results.slice(0, totalCountRows);
    }, [items]);
    const renderItem = useCallback((value, state) => {
        return _jsx(DirectoryBoxRow, { code: value.code, name: value.name, isHighlighted: !!state });
    }, []);
    const renderTotalCount = useCallback((foundCount) => _jsx(TotalCountRow, { visibleCount: foundCount, totalCount: totalCount }), [totalCount]);
    const valueToString = (item) => `${item?.code || ''} ${item?.name || ''}`.trim();
    return (_jsx(ComboBox, { ref: ref, error: error, width: width, onBlur: onBlur, "data-tid": dataTid, getItems: getItems, onFocus: onFocus, renderItem: renderItem, renderValue: renderItem, totalCount: totalCount, maxMenuHeight: maxMenuHeight, onValueChange: onValueChange, valueToString: valueToString, value: getComboBoxValue(value), itemToValue: (item) => item.code, renderTotalCount: renderTotalCount, placeholder: placeholder || 'Начните вводить название', onUnexpectedInput: (query) => ({ code: query, name: '' }) }));
});
DirectoryBox.displayName = 'DirectoryBox';
